import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.10.1_@parcel+watcher@2.5.1_@types+node@22.13.1_magicast@0.3.5_rollup@4.30.1_sass@1.83._ednasnbfpsum6n75mij7x5rnmu/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/build/repo/middleware/auth.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.10.1_@parcel+watcher@2.5.1_@types+node@22.13.1_magicast@0.3.5_rollup@4.30.1_sass@1.83._ednasnbfpsum6n75mij7x5rnmu/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  account: () => import("/opt/build/repo/middleware/account.ts"),
  "client-login": () => import("/opt/build/repo/middleware/client-login.ts"),
  denied: () => import("/opt/build/repo/middleware/denied.ts"),
  "final-onboarding": () => import("/opt/build/repo/middleware/final-onboarding.ts"),
  host: () => import("/opt/build/repo/middleware/host.ts"),
  invite: () => import("/opt/build/repo/middleware/invite.ts"),
  loggin: () => import("/opt/build/repo/middleware/loggin.ts"),
  "non-app": () => import("/opt/build/repo/middleware/non-app.ts"),
  "oauth-invite": () => import("/opt/build/repo/middleware/oauth-invite.ts"),
  "oauth-register": () => import("/opt/build/repo/middleware/oauth-register.ts"),
  oauth: () => import("/opt/build/repo/middleware/oauth.ts"),
  onboarding: () => import("/opt/build/repo/middleware/onboarding.ts"),
  "participent-login": () => import("/opt/build/repo/middleware/participent-login.ts"),
  participent: () => import("/opt/build/repo/middleware/participent.ts"),
  "password-reset": () => import("/opt/build/repo/middleware/password-reset.ts"),
  redirect: () => import("/opt/build/repo/middleware/redirect.ts"),
  switch: () => import("/opt/build/repo/middleware/switch.ts")
}